<template>
  <svg
    id="svg5"
    width="60"
    height="60"
    viewBox="0 0 15.875 15.875"
    version="1.1"
    xml:space="preserve"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:svg="http://www.w3.org/2000/svg"
  >
    <defs id="defs2" />
    <g
      id="layer2"
      transform="matrix(0.94388832,0,0,1.4430768,0.8618412,-3.8704665)"
    >
      <path
        id="path1468"
        class="primary"
        d="m 4.05612,6.2830393 6.647691,-0.014984 4.896131,3.6900499 -6.5565396,3.12e-5 z"
      />
      <path
        id="rect1269-2"
        class="secondary"
        d="M 3.9200139,6.2610359 -0.68953378,9.9772747 1.0848986,9.9868439 4.9581365,6.9514242"
      />
      <rect
        id="rect1201"
        class="secondary"
        width="1.4224795"
        height="1.7650539"
        x="8.5045748"
        y="5.8154058"
      />
    </g>
    <g
      id="g412"
      class="smoke secondary"
      transform="matrix(0.99367454,-0.0734521,0.17168876,0.99367454,-1.1267709,1.410178)"
    >
      <ellipse
        id="path349"
        cx="9.9856272"
        cy="4.6592274"
        rx="0.92042786"
        ry="0.29417565"
      />
      <ellipse
        id="path351"
        cx="9.5526085"
        cy="5.0628638"
        rx="0.64614445"
        ry="0.25445879"
      />
      <ellipse
        id="path353"
        cx="9.1697931"
        cy="6.5747895"
        rx="0.52297038"
        ry="0.2257627"
      />
    </g>
  </svg>
</template>

<style lang="scss" scoped>
.primary {
  fill: $primary-color;
}
.secondary {
  fill: $secondary-color;
}
.smoke {
  opacity: 0;
}
svg {
    stroke: $background-color-default;
    stroke-width: 0.2;
    &:hover {
      .smoke {
        transition: all 1s linear;
        opacity: 50;
        transform: translateY(-50%);
      }
    }
}
</style>
